exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] .sigselect > .vs__dropdown-toggle{\n  border-color: rgba(var(--vs-primary),1);\n}[dir=ltr] .sigselect > .vs__dropdown-toggle{\n  border-right: none !important;\n  border-radius: 6px 0px 0px 6px;\n}[dir=rtl] .sigselect > .vs__dropdown-toggle{\n  border-left: none !important;\n  border-radius: 0px 6px 6px 0px;\n}\n[dir=ltr] .sigbutton {\n  border-left: none;\n  border-radius: 0px 6px 6px 0px;\n}\n[dir=rtl] .sigbutton {\n  border-right: none;\n  border-radius: 6px 0px 0px 6px;\n}\n\n", ""]);

// exports
